export enum ErrorType {
  SCREENING_ERROR = 'Screening Error'
}

export interface GenericError<T> {
  type: ErrorType;
  data?: T;
}
